import { useInternationalization } from '@progress/kendo-react-intl';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { InvoiceDetailsResponse } from 'src/services/useInvoiceDetailsApi';
import { useContextSelector } from 'use-context-selector';
import { InvoiceContext } from '../invoice_details/InvoiceDetailsContext';

interface InvoiceBudgetPeriodInfoProps {
  detailsInfo: InvoiceDetailsResponse;
  isGrandTotalNotMatch: boolean;
}

const InvoiceBudgetPeriodInfo: FC<InvoiceBudgetPeriodInfoProps> = ({
  detailsInfo,
  isGrandTotalNotMatch,
}) => {
  const { t } = useTranslation();
  const intl = useInternationalization();
  const title = useContextSelector(InvoiceContext, (value) => value.title);

  return (
    <section className="mt-2">
      <div className="bg-[#F6F6F6] h-11 text-xs flex items-center font-medium gap-4 px-4 ">
        <>
          <span>
            {title} #:
            <span className="font-bold ml-1">
              {(detailsInfo as InvoiceDetailsResponse)?.invoiceNumber}
            </span>
          </span>
          <span className="text-[#AAAAAA]"> | </span>
          <span>
            {t(`${title} Total Amount`)}:
            <span className={`${isGrandTotalNotMatch ? 'text-error' : ''} font-bold ml-1`}>
              {intl.formatNumber(
                Number((detailsInfo as InvoiceDetailsResponse)?.totalCostAmt) || 0,
                'c2'
              )}
            </span>
          </span>
        </>
      </div>
    </section>
  );
};

export default InvoiceBudgetPeriodInfo;
